import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const aiContentAPI = {
  // Generate content
  generateHomepageHero: async (context = 'general') => {
    const response = await axios.post(
      `${API_URL}/api/ai/generate/homepage-hero?context=${encodeURIComponent(context)}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  generateCategoryDescription: async (categoryId, categoryName) => {
    const response = await axios.post(
      `${API_URL}/api/ai/generate/category-description?category_id=${categoryId}&category_name=${encodeURIComponent(categoryName)}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  enhanceProductDescription: async (productId) => {
    const response = await axios.post(
      `${API_URL}/api/ai/generate/product-description/${productId}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  generatePromotionalBanner: async (promoType, targets, offer) => {
    const params = new URLSearchParams({ promo_type: promoType, targets, offer });
    const response = await axios.post(
      `${API_URL}/api/ai/generate/promotional-banner?${params}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  generateSeoMeta: async (pageName, contentSummary) => {
    const params = new URLSearchParams({ page_name: pageName, content_summary: contentSummary });
    const response = await axios.post(
      `${API_URL}/api/ai/generate/seo-meta?${params}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  generateAboutPage: async () => {
    const response = await axios.post(
      `${API_URL}/api/ai/generate/about-page`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  generateFaq: async () => {
    const response = await axios.post(
      `${API_URL}/api/ai/generate/faq`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  // Content management
  approveContent: async (contentId) => {
    const response = await axios.post(
      `${API_URL}/api/ai/content/${contentId}/approve`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  rejectContent: async (contentId, reason = '') => {
    const response = await axios.post(
      `${API_URL}/api/ai/content/${contentId}/reject?reason=${encodeURIComponent(reason)}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  publishContent: async (contentId) => {
    const response = await axios.post(
      `${API_URL}/api/ai/content/${contentId}/publish`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  revertContent: async (contentId) => {
    const response = await axios.post(
      `${API_URL}/api/ai/content/${contentId}/revert`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  getPendingContent: async () => {
    const response = await axios.get(
      `${API_URL}/api/ai/content/pending`,
      { withCredentials: true }
    );
    return response.data;
  },

  getContentHistory: async (contentType = null, limit = 50) => {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (contentType) params.append('content_type', contentType);
    
    const response = await axios.get(
      `${API_URL}/api/ai/content/history?${params}`,
      { withCredentials: true }
    );
    return response.data;
  },

  // Scheduler
  triggerDailyUpdates: async () => {
    const response = await axios.post(
      `${API_URL}/api/ai/scheduler/run-daily`,
      {},
      { withCredentials: true }
    );
    return response.data;
  }
};

export default aiContentAPI;
